/* eslint-disable */

import * as companyManagementService from "../../services/company";
import * as settings from "../../services/settings";

import { Button, Col, Form, Input, Row, Spin, notification } from "antd";
import React, { useEffect, useState } from "react";

import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { usePermission } from "../../hooks/usePermission";

const { TextArea } = Input;

export const CreateCompanyLine = ({ t, formCompany, type, detailData }) => {
  const { hasPermission, isCompanyFullAccess } = usePermission();
  const can = (p) => isCompanyFullAccess || hasPermission(p);
  const [formCompanyLine] = Form.useForm();
  const { accessToken } = useAccessToken();
  /* eslint-enable no-template-curly-in-string */
  const [companyLineData, setCompanyLineData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onSubmit = async () => {
    const values = await formCompanyLine.getFieldsValue();
    const prepareData = {
      company_id: detailData.id,
      ...values,
    };
    setLoading(true);
    try {
      let message = "";
      if (type === "CREATE" || companyLineData === null) {
        await companyManagementService.createCompanyLine(accessToken, prepareData);
        message = "create company line success";
        setIsDisable(true);
      } else {
        prepareData.id = companyLineData.id;
        await companyManagementService.updateCompanyLine(accessToken, prepareData);
        message = "update company line success";
      }
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{`${message}`}</>);
      await fetchCompanyLine();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateCompanyLine] onSubmit: ", err);
      setLoading(false);
    }
  };

  const fetchCompanyLine = async () => {
    let updateById = detailData.id;
    setLoading(true);
    try {
      const data = await companyManagementService.getCompanyLineById(accessToken, updateById);
      setCompanyLineData(data);
      formCompanyLine.setFieldsValue(data);
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateCompanyLine] fetchCompanyLine: ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken) return;
    if (type !== "CREATE") {
      fetchCompanyLine();
    }
  }, [accessToken, type]);

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="top" justify="start">
          <Col span={12}>
            <Row gutter={10}>
              <Col flex={6}>
                <Form form={formCompanyLine} labelAlign="left" labelCol={{ flex: "180px" }}>
                  <Form.Item
                    label={t("Company_Create.Create_Line.Input_LIFF_ID") + ":"}
                    name="liff_id"
                    key="liff_id"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                  >
                    <Input allowClear={true} size="default" placeholder={"liff id"} />
                  </Form.Item>
                  <Form.Item
                    label={t("Company_Create.Create_Line.Input_Channel_Secret") + ":"}
                    name="channel_secret"
                    key="channel_secret"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                  >
                    <Input allowClear={true} size="default" placeholder={"channel secret"} />
                  </Form.Item>
                  <Form.Item
                    label={t("Company_Create.Create_Line.Input_Channel_Access_Token") + ":"}
                    name="channel_access_token"
                    key="channel_access_token"
                    style={{ marginBottom: "1rem" }}
                    normalize={(value) => value.trim()}
                  >
                    <Input allowClear={true} size="default" placeholder={"channel access token"} />
                  </Form.Item>
                </Form>
              </Col>
              <Col flex={1}></Col>
            </Row>
          </Col>
        </Row>
        {(type === "CREATE" && can(permissions.CompanyLine.ADD)) ||
        (type === "EDIT" && can(permissions.CompanyLine.CHANGE)) ? (
          <Row justify="end" style={{ marginTop: "10px" }}>
            <Col span={24}>
              <Button
                disabled={isDisable}
                type="primary"
                onClick={onSubmit}
                style={{ marginRight: "10px", justifyContent: "end" }}
              >
                {type === "CREATE"
                  ? t("Company_Create.Create_Line.Text_Add_Line")
                  : t("Company_Create.Create_Line.Text_Edit_Line")}
              </Button>
            </Col>
          </Row>
        ) : undefined}
      </Spin>
    </>
  );
};
